import { reject } from "lodash";
import { resolve } from "path";
import events from "./events";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const sendEvent = (data: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...data });

  return new Promise(function (resolve, reject) {
    resolve(true);
    reject(false);
  });
};

const trackCustomEvents = ({ lsEvents, category }: any, extras: any) => {
  const data = { ...extras, ...lsEvents[category] };
  return sendEvent(data);
};

const trackLSEvents = (category: any, extras = {}) => {
  return trackCustomEvents(
    {
      lsEvents: events,
      category,
    },
    extras
  );
};

export { trackLSEvents };
